module.exports = __webpack_public_path__ + "img/us.5fb428d6.svg";